/**
 * Общие константы домена. Единственный источник правды для лимитов и словарей —
 * и сервер, и клиент импортируют отсюда, чтобы валидация нигде не разъезжалась.
 */
export const APP_NAME = 'Загадарь';
/** Валюты, которые мы умеем показывать. Цены везде храним в минорных единицах (копейки/центы). */
export const CURRENCIES = ['RUB', 'USD', 'EUR', 'KZT', 'BYN', 'GEL', 'AMD', 'TRY', 'CNY', 'GBP'];
export const CURRENCY_SYMBOL = {
    RUB: '₽',
    USD: '$',
    EUR: '€',
    KZT: '₸',
    BYN: 'Br',
    GEL: '₾',
    AMD: '֏',
    TRY: '₺',
    CNY: '¥',
    GBP: '£',
};
/** Сколько минорных единиц в одной основной. Все наши валюты — сотые. */
export const CURRENCY_MINOR_UNITS = 100;
export const ITEM_PRIORITIES = ['low', 'normal', 'high', 'must', 'dream'];
export const ITEM_PRIORITY_LABEL = {
    low: 'Было бы приятно',
    normal: 'Хочу',
    high: 'Очень хочу',
    must: 'Сильно хочу',
    dream: 'Мечта',
};
/** Ступень 1..5 для компактного индикатора («степень хотения»). */
export const ITEM_PRIORITY_STEP = {
    low: 1,
    normal: 2,
    high: 3,
    must: 4,
    dream: 5,
};
/**
 * Видимость списка.
 * - private — виден только владельцу;
 * - friends — виден друзьям (подтверждённым с обеих сторон);
 * - link    — виден любому, у кого есть секретная ссылка (share token);
 * - public  — виден любому авторизованному пользователю по профилю.
 */
export const LIST_VISIBILITIES = ['private', 'friends', 'link', 'public'];
export const LIST_VISIBILITY_LABEL = {
    private: 'Только я',
    friends: 'Друзья',
    link: 'По ссылке',
    public: 'Все пользователи',
};
/** Состояние брони. Владелец списка не видит ни одного из них — см. domain/visibility. */
export const RESERVATION_STATUSES = ['reserved', 'purchased'];
export const FRIENDSHIP_STATUSES = ['pending', 'accepted', 'declined', 'blocked'];
export const LIMITS = {
    emailMax: 254,
    passwordMin: 8,
    passwordMax: 200,
    displayNameMin: 1,
    displayNameMax: 60,
    usernameMin: 3,
    usernameMax: 32,
    listTitleMax: 120,
    listDescriptionMax: 2000,
    itemTitleMax: 300,
    itemDescriptionMax: 4000,
    itemNoteMax: 500,
    urlMax: 2048,
    itemsPerList: 500,
    listsPerUser: 100,
    imagesPerItem: 12,
    maxQuantity: 99,
};
/** Регулярка для @username: латиница, цифры, подчёркивание; начинается с буквы. */
export const USERNAME_RE = /^[a-z][a-z0-9_]{2,31}$/;
/** Время жизни сессии — 90 дней, скользящее окно. */
export const SESSION_TTL_MS = 90 * 24 * 60 * 60 * 1000;
/** Как долго держим в кэше распарсенную ссылку. */
export const LINK_PREVIEW_TTL_MS = 24 * 60 * 60 * 1000;
/**
 * Сколько живёт в памяти карточка, у которой чего-то не хватает.
 *
 * Полная карточка за сутки не портится: название и фотография у товара те же.
 * А неполная — это чаще всего не свойство товара, а свойство минуты, в которую
 * мы спросили. Поймано на живом 06.08.2026: Wildberries притормозил наш адрес
 * по частоте, карточка приехала без цены и легла в память на сутки. Дальше
 * человек жал «обновить с сайта» и получал ту же пустую цену — хотя площадка
 * отпустила уже через полчаса, и прямой разбор той же ссылки отдавал 1846 ₽.
 *
 * Полчаса — это компромисс: достаточно, чтобы десяток открытий карточки подряд
 * не превращались в десяток походов на площадку, и достаточно мало, чтобы
 * человек мог просто попробовать ещё раз и получить цену.
 */
export const LINK_PREVIEW_TTL_НЕПОЛНОЙ_MS = 30 * 60 * 1000;
//# sourceMappingURL=constants.js.map